(function () {
    'use strict';

    angular.module('NaviaqWebApp').controller('unitsBatchDetailsModalAdministrationController', unitsBatchDetailsModalAdministrationController);

    unitsBatchDetailsModalAdministrationController.$inject = [
        '$translate',
        '$rootScope',
        '$scope',
        '$windowInstance',
        'currentFormType',
        'formTypes',
        'unitService',
        'unitId',
        'unitBatchId',
        'unitBatchService',
        'mediaService',
        '$q',
        'confirmDialogService'
    ];

    function unitsBatchDetailsModalAdministrationController(
        $translate,
        $rootScope,
        $scope,
        $windowInstance,
        currentFormType,
        formTypes,
        unitService,
        unitId,
        unitBatchId,
        unitBatchService,
        mediaService,
        $q,
        confirmDialogService
    ) {
        $scope.unitBatch = {};
        $scope.units = []
        $scope.selectedUnit = {};
        $scope.unitsOptions = {
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: function (options) {
                        options.success($scope.units);
                    }
                },
                sort: { field: 'description', dir: 'asc' },

            }),
            dataValueField: 'id',
            dataTextField: 'description',
            optionLabel: $translate.instant('ADMIN_CUSTOMERS_SELECT_UNIT')
        };
        $scope.parentUnitSelectionEnabled = false;

        $scope.close = close;
        $scope.validateForm = validateForm;
        $scope.viewCertificate = viewCertificate;
        $scope.deleteCertificate = deleteCertificate;

        $scope.certificate = null;

        $scope.fileUploadOptions = {
            multiple: false,
            localization: {
                select: $translate.instant('G_SELECT')
            }
        };
        initController();

        async function initController() {
            try {
                if (currentFormType === formTypes.edit) {
                    $scope.unitBatch = await unitBatchService.getUnitBatch(unitBatchId);
                    $scope.units = [ $scope.unitBatch.unit ];
                    $scope.selectedUnit = $scope.unitBatch.unit
                }
                else if (currentFormType === formTypes.add) {
                    $scope.units = await unitService.getUnitsAsDropdownByContractorId($rootScope.authData.contractorId)
                    
                    if (unitId) {
                        $scope.units = $scope.units.filter((unit) => {
                            return unit.id == unitId;
                        })
                        $scope.selectedUnit = $scope.units[0];
                    }
                    else {
                        $scope.units = $scope.units.filter((unit) => {
                            return unit.isActive == true;
                        })
                        $scope.parentUnitSelectionEnabled = true;
                    }
                }
    
                $scope.unitsOptions.dataSource.read();
            } catch (error) {
                console.error(error)
            }
        }

        function validateForm(event) {
            event.preventDefault();

            // Clear any existing validation messages
            $scope.validator.hideMessages();

            // Add custom validation for certificate date
            if (issueDateIsRequired() && !$scope.unitBatch.certificateIssuedDate) {
                //this command gives an error message and should be fixed if necessary/possible
                //$scope.validator.addError('certificateIssuedDate', $translate.instant('CERTIFICATE_DATE_REQUIRED'));
                return;
            }

            if ($scope.validator.validate()) {
                $rootScope.$broadcast('showBusyIndicator', {
                    id: 'unitDetailsModalIndicator',
                    destination: '.k-widget.k-window',
                    overlay: true
                });

                //remove timezone information from certificateIssuedDate field
                $scope.unitBatch.certificateIssuedDate = $scope.unitBatch.certificateIssuedDate?.toDateString();

                switch (currentFormType) {
                    case formTypes.add:
                        uploadFile().then(function (mediaId) {
                            $scope.unitBatch.unitId = $scope.selectedUnit.id;

                            if (mediaId) {
                                $scope.unitBatch.mediaId = mediaId;
                            }

                            $scope.unitBatch.isActive = true;
                            unitService.addUnitBatch($scope.unitBatch)
                                .then(unitBatch => close($scope.unitBatch))
                                .catch(() => close());
                        });
                        break;
                    case formTypes.edit:
                        uploadFile().then(function (mediaId) {
                            
                            if (mediaId) {
                                $scope.unitBatch.mediaId = mediaId;
                            }

                            unitService.updateUnitBatch($scope.unitBatch)
                                .then(unitBatch => close($scope.unitBatch))
                                .catch(() => close());
                        });
                        break;
                    default:
                        close();
                        break;
                }
            }
        }

        $scope.uploadFile = function () {
            $('#file-upload').click();
        }

        function uploadFile() {
            const deferred = $q.defer();
            if ($scope.fileArray && $scope.fileArray[0]) {
                var file = $scope.fileArray[0];
                mediaService.asyncEncodeImageFile(file)
                    .then(function (encodedImage) {
                        mediaService.uploadFileWebApi(file.name, encodedImage)
                            .then(function (newMediaId) {
                                deferred.resolve(newMediaId);
                            });
                    }, function (error) {
                        deferred.reject(error);
                    });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        function close(param) {
            $rootScope.$broadcast('hideBusyIndicator', 'unitDetailsModalIndicator');
            $rootScope.$broadcast('hideBusyIndicator', 'deleteCertificateIndicator');
            $windowInstance.close(param);
        }

        function viewCertificate(mediaId) {
            const mediaUrl = mediaService.createMediaUrl(mediaId)
            window.open(mediaUrl, "_blank");
        }

        function deleteCertificate() {
            confirmDialogService.open(
                { modalWidth: 400, modalHeight: 150 },
                $translate.instant('CONFIRM_DELETE_CERTIFICATE_MESSAGE'),
                null,
                $translate.instant('G_YES'),
                $translate.instant('G_NO')
            ).then(function (result) {
                if (result) {
                    $rootScope.$broadcast('showBusyIndicator', {
                        id: 'deleteCertificateIndicator',
                        destination: '.k-widget.k-window',
                        overlay: true
                    });
                    return unitService.deleteCertificateFromUnitBatch($scope.unitBatch.id, $scope.unitBatch.mediaId);
                }
                return $q.reject();
            }).then(function (response) {
                $scope.unitBatch.mediaId = null;
                $rootScope.$broadcast('hideAllBusyIndicator');
            }).catch(function (error) {
                $rootScope.$broadcast('hideAllBusyIndicator');
            });
        }

        $scope.issueDateIsRequired = issueDateIsRequired;
        function issueDateIsRequired() { 
            return ($scope.fileArray && $scope.fileArray.length > 0) || ($scope.unitBatch && $scope.unitBatch.mediaId !== null);
        }

    }
})();
